module.exports = __webpack_public_path__ + "img/help-content-8.0f2248f1.png";